export const IgniteAdmins = [
    "h.srinivasan",
    "varsha.a.tyagi",
    "uma.rani.battu",
    "ankur.e.mishra",
    "arpita.m.singh",
    "aluru.akash",
    "nikita.apte",
    "shubham.i.tyagi",
    "jeevadharani.ramanan",
    "srikanth.narabathoju",
    "dhaval.atul.pantojee"
]